export function formatGtagLabel(...parts: (string | undefined | null)[]): string {
  return parts
    .filter((part): part is string =>
      Boolean(part && typeof part === "string" && part.trim()),
    )
    .join(" - ");
}
